const realmSlug = () => {
  switch (window.location.hostname) {
    case 'admin.influxdata.co':
      return 'influx';
    case 'influencem.influxdata.co':
      return 'influencem';
    default: {
      const customRealm = window.localStorage.getItem('REALM');
      return customRealm ? customRealm : 'influx';
    }
  }
};

export default realmSlug();
